export default "__VITE_ASSET__0g$$Nkln__"